import {
  Box,
  makeStyles,
  useTheme,
  FormControl,
  Select,
} from "@material-ui/core";
import React, { useEffect, forwardRef, useState } from "react";
import MaterialTable from "material-table";
import { useSelector } from "react-redux";
import { backend } from "../../../../api";
import { MdFilterList } from "react-icons/md";
import moment from "moment";
import { Skeleton } from "@material-ui/lab";
import { toast } from "react-toastify";
import { tableIcons } from "../../tableIcons";

const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "170px",
  },
}));

function Orders(props) {
  const classes = useStyles(props);
  const theme = useTheme();
  const [orders, setOrders] = useState([]);
  const [ordersList, setOrdersList] = useState();
  const state = useSelector((state) => state.auth);
  useEffect(() => {
    handleFetchOrders();
  }, []);
  const handleFetchOrders = () => {
    backend
      .get(`/bookorder/author?author_id=${state.currentUser.author._id}`)
      .then((res) => {
        setOrders(res.data.data);
        console.log(res.data.data)
        setOrdersList(res.data.data);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };
  const handleFilterOrder = (e) => {
    if (e.target.value === "all") {
      setOrdersList(orders);
    } else {
      setOrdersList(orders.filter((order) => order.status === e.target.value));
    }
  };
  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <h2 className={classes.tabHeading}>My Orders</h2>
        <FormControl
          variant="outlined"
          className={classes.filterSelect}
          startIcon={<MdFilterList />}
        >
          <Select native onChange={handleFilterOrder}>
            <option value="all">All</option>
            <option value="requested">Requested</option>
            <option value="placed">Placed</option>
            <option value="shipped">Shipped</option>
            <option value="delivered">Delivered</option>
            <option value="cancelled">Cancelled</option>
            <option value="declined">Declined</option>
          </Select>
        </FormControl>
      </Box>
      {ordersList ? (
        <MaterialTable
          icons={tableIcons}
          options={{
            toolbar: false,
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: theme.palette.primary.light,
              color: theme.palette.secondary.light,
              fontWeight: 600,
              fontSize: 16,
            },
            rowStyle: {
              alignItems: "center",
            },
            search: false,
            filtering: true,
            title: false,
          }}
          columns={[
            // { title: "Order Id", field: "orderId" },
            { title: "Date", field: "date" },
            { title: "Book", field: "book" },
            { title: "Customer", field: "user" },
            { title: "Price", field: "price" },
            { title: "Status", field: "status" },
          ]}
          data={ordersList.map((order, index) => {
            return {
                // orderId: order._id,
              date: moment(order.date_updated).format("MMMM Do YYYY, h:mm a"),
              book: order.book.book_title,
              user: order.user.user.name,
              price: order.author_amount,
              status: order.status,
            };
          })}
        ></MaterialTable>
      ) : (
        <Box>
          <Skeleton animation="wave" />
        </Box>
      )}
    </div>
  );
}

export default Orders;
